module.exports = {
  bulmaCssVariablesDefs: {
    link: {
      calls: [
        {
          fn: "color-invert",
          fnArg: null,
          composeArg: null,
        },
        {
          fn: "dark-color",
          fnArg: null,
          composeArg: null,
        },
        {
          fn: "light-color",
          fnArg: null,
          composeArg: null,
        },
      ],
    },
    primary: {
      calls: [
        {
          fn: "color-invert",
          fnArg: null,
          composeArg: null,
        },
        {
          fn: "dark-color",
          fnArg: null,
          composeArg: null,
        },
        {
          fn: "light-color",
          fnArg: null,
          composeArg: null,
        },
      ],
    },
  },
};
